import axios from "axios";
import Cookies from "js-cookie";
import router from "../router";
import Vue from "vue";
import vm from "../main.js";
import qs from "qs";

var root = process.env.API_ROOT;

// axios.defaults.timeout = 5000
axios.defaults.baseURL = root;
// axios.defaults.withCredentials = true;
// http request 拦截器
axios.interceptors.request.use(
  (config) => {
    // console.log("config", JSON.stringify(config.data));
    // if(config.headers)
    // config.data = qs.stringify(config.data);
    // console.log("configconfig", JSON.stringify(config.data));
    let token;
    let device = "wap";
    if (vm.$store.state.device === "wap") {
      if (vm.$route.query.device) {
        device = vm.$route.query.device;
      }
    } else {
      device = vm.$store.state.device;
    }
    if (device === "android") {
      try {
        if (MyWebView.getNativeParamValue("token")) {
          token = MyWebView.getNativeParamValue("token");
        }
      } catch (e) {
        token = vm.$store.state.token;
      }
    } else if (device === "ios") {
      if (vm.$store.state.token) {
        token = vm.$store.state.token;
      } else {
        token = "Bearer " + vm.$route.query.token;
      }
    } else {
      token = localStorage.getItem("_token");
    }
    if (
      config.headers &&
      config.headers["Content-Type"] === "multipart/form-data"
    ) {
      config.headers = {
        "Content-Type": "multipart/form-data",
        Authorization: token,
        device: "wap",
        Language: "zh-CN",
        "Access-Control-Allow-Origin": "*"
      };
    } else {
      if (typeof config.data !== "string") {
        config.data = JSON.stringify(config.data);
      }
      config.headers = {
        "Content-Type": "application/json",
        Authorization: token,
        device: "wap",
        Language: "zh-CN"
      };
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

function clearStorage() {
  localStorage.removeItem("_token");
}
// http response 拦截器
axios.interceptors.response.use(
  (response) => {
    let token = response.headers.Authorization;
    if (token) {
      axios.defaults.headers.common["Authorization"] = token;
    }
    if (response.status == 200) {
      // debugger;
      // if (!vm.$store.state.userType) {
      //   vm.$get("api/person/current").then(data => {
      //     vm.$store.dispatch("commitChangeType", data.userType);
      //     vm.$store.dispatch("commitChangeUserId", data.id);
      //     if (vm.$store.state.userType == "1") {
      //       vm.$store.dispatch("commitChangeSupId", null);
      //     } else {
      //       if (vm.$route.meta && vm.$route.meta.driver) {
      //         return;
      //       }
      //       vm.$get("api/supplier/current-sample").then(res => {
      //         vm.$store.dispatch("commitChangeSupId", res.id);
      //       });
      //     }
      //   });
      // }
    }
    return response;
  },
  (error) => {
    if (error) {
      if (error.response) {
        switch (error.response.status) {
          case 401:
            // 这里写清除token的代码
            if (vm.$store.state.device === "wap") {
              clearStorage();
              if (vm.$store.state.browse === "general") {
                if (vm.$route.meta && vm.$route.meta.driver) {
                  console.log(vm.$route);
                  if (vm.$route.path !== "/driver/login") {
                    router.replace({
                      path: "/driver/login",
                      query: { redirect: router.currentRoute.fullPath }, //登录成功后跳入浏览的当前页面
                    });
                  }
                } else {
                  if (vm.$route.path !== "/user/login") {
                    router.replace({
                      path: "/user/login",
                      query: { redirect: router.currentRoute.fullPath }, //登录成功后跳入浏览的当前页面
                    });
                  }
                }
              } else {
                router.replace({
                  path: "/dd-login",
                  query: { redirect: router.currentRoute.fullPath }, //登录成功后跳入浏览的当前页面
                });
              }
            } else {
              document.location = "http://action:1515/?";
            }
            break;
          case 400: // 未登录状态码
            if (error.response.data) {
              Vue.$vux.toast.text(error.response.data.message);
            }
            break;
          case 403:
            if (error.response.data) {
              Vue.$vux.toast.text(error.response.data.message);
            }
            break;
          case 404:
          case 500:
            if (error.response.data) {
              Vue.$vux.toast.text(error.response.data.message);
            }
            break;
          case 602: // curd错误
            if (error.response.data && error.response.data.message) {
              Vue.$vux.toast.text(error.response.data.message);
            }
            break;
          //break;
          case 702: // 系统未授权
            Vue.$vux.toast.text("系统未授权");
            break;
        }
      }
    }
    return Promise.reject(error.response.data);
  }
);

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, { params: params })
      .then((response) => {
        resolve(response.data);
        Vue.prototype.$headers = response.headers;
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * 需要的特殊get请求
 * */
export function fetch(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, params)
      .then((response) => {
        resolve(response.data);
        Vue.prototype.$headers = response.headers;
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * 封装search方法
 * @param url
 * @param params 参数 为空时 传 {}
 * @param searchData 搜索字段 {a: 1, b: 2}
 * @returns {Promise}
 */

export function search(url, params = {}, searchData = {}) {
  let CancelToken = axios.CancelToken;
  if (cancel) {
    cancel();
  }
  let stringData = "";
  url = url + "?";
  if (params) {
    Object.keys(params).forEach(function (key) {
      stringData = stringData + `${key}=${params[key]}&`;
    });
  }
  if (searchData) {
    Object.keys(searchData).forEach(function (key) {
      if (searchData[key] || searchData[key] == "0") {
        stringData =
          stringData +
          `propertyNames=${key}&propertyValues=${searchData[key]}&`;
      }
    });
  }
  let finallUrl = (url + stringData).substring(
    0,
    (url + stringData).length - 1
  );

  return new Promise((resolve, reject) => {
    axios
      .get(finallUrl, {
        cancelToken: new CancelToken((c) => {
          cancel = c;
        }),
      })
      .then((response) => {
        resolve(response.data);
        Vue.prototype.$headers = response.headers;
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

let cancel;

export function post(url, data = {}, headers = {}) {
  //减少请求次数
  if (cancel) {
    cancel();
  }
  return new Promise((resolve, reject) => {
    let CancelToken = axios.CancelToken;
    axios
      .post(url, data, {
        cancelToken: new CancelToken((c) => {
          cancel = c;
        }),
        headers: headers,
      })
      .then(
        (response) => {
          resolve(response.data);
        },
        (err) => {
          reject(err);
        }
      );
  });
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * 封装del请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function del(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.delete(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

export function setCookies(name, data) {
  Cookies.set(name, data);
}

export function getCookies(name, data) {
  return Cookies.set(name, data);
}

export function sortData(request) {
  for (let i = 0; i < request.length; i++) {
    request[i]["product"] = [[], []];
    if (request[i].productInfo == "") {
      continue;
    }
    let product = JSON.parse(request[i].productInfo);
    for (let j = 0; j < product.length; j++) {
      for (let key in product[j]) {
        request[i].product[0].push(key);
        request[i].product[1].push(product[j][key]);
      }
    }
  }
  return request;
}



// WEBPACK FOOTER //
// ./src/utils/http-service.js